import React, { createContext, FC, useEffect, useState } from 'react';

import { useGetVideoThemeById } from '@/services';
import { ContextVideoTheme } from '@/types/VideoThemeTypes';

type Props = {
  themeId: number;
  children: React.ReactNode;
};

type VideoThemeContextType = {
  themeData: ContextVideoTheme;
  isThemeLoading: boolean;
  refetch: () => void;
};

const defaultBehaviour: VideoThemeContextType = {
  themeData: null,
  isThemeLoading: true,
  refetch: () => 0
};

export const VideoThemeContext = createContext<VideoThemeContextType>(defaultBehaviour);

export const VideoThemeProvider: FC<Props> = ({ themeId, children }) => {
  const [themeData, setThemeData] = useState<ContextVideoTheme>(null);
  const [isThemeLoading, setIsThemeLoading] = useState<boolean>(true);

  const { data, refetch } = useGetVideoThemeById(themeId);

  useEffect(() => {
    if (data) {
      setThemeData(data?.data);
      setIsThemeLoading(false);
    }
  }, [data]);

  return (
    <VideoThemeContext.Provider value={{ themeData, isThemeLoading, refetch }}>
      {children}
    </VideoThemeContext.Provider>
  );
};
